import ApiPath from "@viz-ui/services/apiPath/apiPathService";
import logger from "@viz-ui/services/logger/logger";
import { createAngularCompatibleMapService } from "@viz-ui/services/charts/chartBackendServices";

angular
  .module("acl.visualizer.charts.backend")
  .service("MapChartBackendService", (queuedHttp, ChartBackendService, DataModel, AppConfig) => {
    const useMigrated = AppConfig.features && AppConfig.features.migratedMapChartService;
    if (useMigrated) {
      logger.log("🚀 Using migrated TypeScript MapChartBackendService");
      const tsService = createAngularCompatibleMapService(queuedHttp, ApiPath, ChartBackendService);
      return {
        fetchJson: (tableId, filter, config) => {
          const myRecords = DataModel.filterConfig.myRecords();
          const openStatuses = DataModel.filterConfig.openStatuses();
          const raw = DataModel.toSaveViz();
          const requestParams = { raw, myRecords, openStatuses };
          const chartIndex = requestParams.raw.visualizations.findIndex(d =>
            angular.equals(d.config.dataConfig, config)
          );
          requestParams.raw.visualizations[chartIndex] = convertToTableVisualization(
            requestParams.raw.visualizations[chartIndex]
          );
          return tsService.fetchJson(tableId, chartIndex, requestParams);
        },
        getRepresentation: tsService.getRepresentation,
      };
    }
    logger.log("📊 Using original Angular MapChartBackendService");
    return {
      fetchJson: (tableId, filter, config) => {
        const myRecords = DataModel.filterConfig.myRecords();
        const openStatuses = DataModel.filterConfig.openStatuses();
        const raw = DataModel.toSaveViz();
        const requestParams = { raw, myRecords, openStatuses };
        const chartIndex = requestParams.raw.visualizations.findIndex(d => {
          return angular.equals(d.config.dataConfig, config);
        });

        requestParams.raw.visualizations[chartIndex] = convertToTableVisualization(
          requestParams.raw.visualizations[chartIndex]
        );

        return queuedHttp.post(url(tableId, chartIndex), requestParams);
      },

      getRepresentation: (resultData, config) => {
        const rowFieldNames = resultData.config.rows.map(d => d.field_name);
        const valueFieldNames = resultData.config.values.map(d => d.field_name);
        const rowParsers = resultData.config.rows.map(d => ChartBackendService.getParserForType(d.data_type));
        const valueParsers = resultData.config.values.map(d => ChartBackendService.getParserForType(d.data_type));
        return {
          config: angular.copy(resultData.config),
          values: resultData.values.map(valueObj => ({
            columns: {},
            rows: valueObj.rows.map((d, i) => {
              const rowFieldName = rowFieldNames[i];
              return { [rowFieldName]: rowParsers[i](valueObj.rows[i][rowFieldName]) };
            }),
            values: valueFieldNames.reduce((accumulator, valueFieldName, index) => {
              accumulator[valueFieldName] = valueParsers[index](valueObj.values[valueFieldName]);
              return accumulator;
            }, {}),
          })),
        };
      },
    };

    function url(tableId, chartIndex) {
      return ApiPath.table.getSummaryTableDataUrl(tableId) + "?chart_index=" + chartIndex;
    }

    function convertToTableVisualization(mapChartVisualization) {
      return {
        id: mapChartVisualization.id,
        title: mapChartVisualization.title,
        type: "MapChart",
        config: {
          displayConfig: {},
          dataConfig: mapChartVisualization.config.dataConfig,
        },
      };
    }
  });
